import Linkify from 'linkify-react';

const linkifyOptions = {
  className: 'text-blue-600 hover:text-blue-800 underline hover:no-underline',
  target: '_blank',
  rel: 'noopener noreferrer',
  validate: {
    url: (value) => /^https?:\/\//.test(value), // Only linkify URLs with http:// or https://
  }
};

export default function LinkifyText({ children, className = "" }) {
  return (
    <Linkify options={linkifyOptions} as="span" className={className}>
      {children}
    </Linkify>
  );
}
